<script setup lang="ts">
import UserPresenter from '@satellite/components/elements/presenters/user/UserPresenter.vue';
import YardAssetPresenterV2 from '@satellite/components/elements/presenters/YardAssetPresenterV2.vue';
import useYardTaskCheckedEvent from './useYardTaskCheckedEvent';

import type { YardTaskTimelineEvent } from './types';

interface Props {
  event: YardTaskTimelineEvent;
  timezone: string;
  locale: string;
}

const props = defineProps<Props>();

const { formattedCreatedTime, user, leadIn, assetContainerId } = useYardTaskCheckedEvent(
  props.event,
  {
    timezone: props.timezone,
    locale: props.locale
  }
);
</script>

<template>
  <div class="d-flex flex-column gap-1 align-start justify-start">
    <span class="d-flex flex-row flex-wrap align-center justify-start gap-1">
      <user-presenter
        v-if="user"
        class="typography-body-sm-bold text--color-text-secondary"
        :user="user"
        :display-fields="['name']" />
      <span class="typography-body-sm">{{ leadIn }}</span>
      <yard-asset-presenter-v2
        v-if="assetContainerId"
        mode="lazy-live"
        :asset-id="assetContainerId"
        :display-fields="['code']"
        :asset-code-props="{ class: 'typography-body-sm-bold' }" />
    </span>
    <span v-if="formattedCreatedTime" class="typography-caption text--color-text-tertiary">
      {{ formattedCreatedTime }}
    </span>
  </div>
</template>
